import type { IPosthogSdk, PosthogMode } from "./types";
import { PosthogSDKWrapper } from "./wrapper";
import { PosthogSDKReal } from "./real";

export interface PosthogSDKSettings {
  mode: PosthogMode;
  apiKey?: string;
  apiHost?: string;
}

export class PosthogSDKFactory {
  static createInstance(settings: PosthogSDKSettings): IPosthogSdk {
    if (settings.mode === "local") {
      return new PosthogSDKWrapper();
    }
    if (!settings.apiKey) {
      throw new Error("Cannot create PostHog SDK in prod mode without an API key");
    }
    return new PosthogSDKReal(settings.apiKey, settings.apiHost);
  }
}
